import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useHistory } from "react-router-dom";
import { useDeadline } from "../../contexts/DeadlineContext";
import {
  Grid, TextField, Button, Typography, IconButton, Box,
  FormControl, InputLabel, Select, MenuItem, RadioGroup,
  FormControlLabel, Radio, Checkbox,
} from '@mui/material';
import { Add, Delete } from '@mui/icons-material';
import swal from 'sweetalert';
import ConferenceNavbar from "../../frontend/Conference/ConferenceNavbar";
const MAX_PARTICIPANTS = 10;
const titles = ['Mr', 'Mrs', 'Ms', 'Dr', 'Prof', 'Eng', 'Sheikh'];
const countries = [
  'Afghanistan', 'Albania', 'Algeria', 'Andorra', 'Angola', 'Antigua and Barbuda', 'Argentina', 'Armenia', 'Australia', 'Austria',
  'Azerbaijan', 'Bahamas', 'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bhutan',
  'Bolivia', 'Bosnia and Herzegovina', 'Botswana', 'Brazil', 'Brunei', 'Bulgaria', 'Burkina Faso', 'Burundi', 'Cabo Verde', 'Cambodia',
  'Cameroon', 'Canada', 'Central African Republic', 'Chad', 'Chile', 'China', 'Colombia', 'Comoros', 'Congo', 'Costa Rica',
  'Croatia', 'Cuba', 'Cyprus', 'Czech Republic', 'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic', 'Ecuador', 'Egypt',
  'El Salvador', 'Equatorial Guinea', 'Eritrea', 'Estonia', 'Eswatini', 'Ethiopia', 'Fiji', 'Finland', 'France', 'Gabon',
  'Gambia', 'Georgia', 'Germany', 'Ghana', 'Greece', 'Grenada', 'Guatemala', 'Guinea', 'Guinea-Bissau', 'Guyana',
  'Haiti', 'Honduras', 'Hungary', 'Iceland', 'India', 'Indonesia', 'Iran', 'Iraq', 'Ireland', 'Israel',
  'Italy', 'Jamaica', 'Japan', 'Jordan', 'Kazakhstan', 'Kenya', 'Kiribati', 'Kuwait', 'Kyrgyzstan', 'Laos',
  'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libya', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Madagascar', 'Malawi',
  'Malaysia', 'Maldives', 'Mali', 'Malta', 'Marshall Islands', 'Mauritania', 'Mauritius', 'Mexico', 'Micronesia', 'Moldova',
  'Monaco', 'Mongolia', 'Montenegro', 'Morocco', 'Mozambique', 'Myanmar', 'Namibia', 'Nauru', 'Nepal', 'Netherlands',
  'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'North Korea', 'North Macedonia', 'Norway', 'Oman', 'Pakistan', 'Palau',
  'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Poland', 'Portugal', 'Qatar', 'Romania', 'Russia',
  'Rwanda', 'Saint Kitts and Nevis', 'Saint Lucia', 'Saint Vincent and the Grenadines', 'Samoa', 'San Marino', 'Sao Tome and Principe', 'Saudi Arabia', 'Senegal', 'Serbia',
  'Seychelles', 'Sierra Leone', 'Singapore', 'Slovakia', 'Slovenia', 'Solomon Islands', 'Somalia', 'South Africa', 'South Korea', 'South Sudan',
  'Spain', 'Sri Lanka', 'Sudan', 'Suriname', 'Sweden', 'Switzerland', 'Syria', 'Taiwan', 'Tajikistan', 'Tanzania',
  'Thailand', 'Timor-Leste', 'Togo', 'Tonga', 'Trinidad and Tobago', 'Tunisia', 'Turkey', 'Turkmenistan', 'Tuvalu', 'Uganda',
  'Ukraine', 'United Arab Emirates', 'United Kingdom', 'United States', 'Uruguay', 'Uzbekistan', 'Vanuatu', 'Vatican City', 'Venezuela', 'Vietnam',
  'Yemen', 'Zambia', 'Zimbabwe'
];

const ConferenceParticipantGroupRegistration = () => {
  const history = useHistory();
  const { offButton, abstractHomeSetup, getAbstractDeadLineStatus, triggerRefresh } = useDeadline();
  const gradientBackground = '#05597D';
  const event_affiliate_status = localStorage.getItem('event_affiliation_source');

  const [participants, setParticipants] = useState([
    {
      title: '',
      name: '',
      email: '',
      phone: '',
      profession: '',
      gender: '0',
      country: 'Saudi Arabia',
      city: '',
      category: '',
      isParent: true,
      selectedConferences: [],
      couponCodes: {},
      couponDiscounts: {},
      couponMessages: {},
      couponValidity: {},
    },
  ]);

  const [conferenceCategoryData, setConferenceCategoryData] = useState([]);
  const [currentDateTime, setCurrentDateTime] = useState(null);
  const [conferenceTotalSeatCount, setConferenceTotalSeatCount] = useState(0);
  const [participantConferenceCategories, setParticipantConferenceCategories] = useState({});
  const [couponCodes, setCouponCodes] = useState([]);
  const [conferenceUsedCoupons, setConferenceUsedCoupons] = useState([]);
  const [totalAmountCouponAplied, setTotalAmountCouponAplied] = useState(0);
  const [totalAmountPrice, setTotalAmountPrice] = useState(0);
  const [alreadyRegisteredEmails, setAlredayRegisteredEmail] = useState([]);
  const eventid = localStorage.getItem('eventid');

  // Currency state
  const defaultCurrency = abstractHomeSetup?.default_currency || 'USD';
  useEffect(() => {
    if (defaultCurrency) {
      setSelectedCurrency(defaultCurrency);
    }
  }, [defaultCurrency]);

  const [selectedCurrency, setSelectedCurrency] = useState(defaultCurrency);
  const currencyOptions = [
    { value: 'SAR', label: 'Saudi Riyal' },
    { value: 'USA', label: 'US Dollar' },
    { value: 'ARE', label: 'UAE Dirham' },
  ];

  const currencySymbols = {
    'SAR': 'SAR',
    'USA': '$',
    'ARE': 'AED'
  };

  // Fetch conference categories on mount
  useEffect(() => {
    if (!eventid) return;

    axios.get(`api/conference-category-front-index?id=${eventid}`)
      .then(res => {
        if (res.status === 200) {
          setConferenceCategoryData(res.data.conferenceCategories || []);
          setCurrentDateTime(res.data.currentDateTime);
        } else {
          swal('Error', "Check API Something Wrong", 'error');
        }
      })
      .catch(() => {
        swal('Error', "Failed to fetch categories", 'error');
      });
  }, [eventid]);

  // Fetch coupon codes
  useEffect(() => {
    axios.get(`api/conference-manage-coupon-index-front?id=${eventid}`)
      .then(res => {
        if (res.status === 200) {
          setCouponCodes(Array.isArray(res.data.conferenceCouponFront) ? res.data.conferenceCouponFront : []);
        } else {
          swal('Error', "Check API Something Wrong", 'error');
        }
      })
      .catch(() => {
        swal('Error', "Failed to fetch coupons", 'error');
      });
  }, [eventid]);

  // Fetch used coupons
  useEffect(() => {
    axios.get(`api/conference-participant-used-coupeons?id=${eventid}`)
      .then(res => {
        if (res.status === 200) {
          setConferenceUsedCoupons(res.data.usedCoupons || []);
        } else {
          swal('Error', "Check API Something Wrong", 'error');
        }
      })
      .catch(() => {
        swal('Error', "Failed to fetch used coupons", 'error');
      });
  }, [eventid]);

  // Get price based on selected currency
  const getPriceByCurrency = (conference, currency) => {
    switch (currency) {
      case 'SAR':
        return parseFloat(conference.conference_amount) || 0;
      case 'USA':
        return parseFloat(conference.conference_doller_price) || 0;
      case 'ARE':
        return parseFloat(conference.conference_aed_price) || 0;
      default:
        return parseFloat(conference.conference_amount) || 0;
    }
  };

  // Handle category selection
  const handleregistration = (e, participantIndex) => {
    const selectedCategoryId = e.target.value;
    handleChange(participantIndex, 'category', selectedCategoryId);

    axios.get(`api/conference-category-front-single/${selectedCategoryId}`)
      .then(res => {
        if (res.status === 200) {
          setParticipantConferenceCategories(prev => ({
            ...prev,
            [participantIndex]: Array.isArray(res.data.swsd?.conferences) ? res.data.swsd.conferences : [],
          }));
          setConferenceTotalSeatCount(res.data.totalSeatCount || 0);
        } else {
          swal('Error', 'Check API Something Wrong', 'error');
        }
      })
      .catch(() => {
        swal('Error', 'An error occurred while fetching data from the API', 'error');
      });
  };

  // Handle currency change
  const handleCurrencyChange = (event) => {
    setSelectedCurrency(event.target.value);
  };

  // Handle coupon code changes
  const handleCouponCodeChange = (conferenceId, newValue, participantIndex) => {
    const currentDate = new Date().toISOString().split('T')[0];
    const matchingCoupon = couponCodes.find(
      coupon => coupon.coupon_code === newValue && coupon.conference_id === conferenceId
    );

    setParticipants(prev => {
      const updated = [...prev];
      const participant = updated[participantIndex];
      const conferences = participantConferenceCategories[participantIndex] || [];
      const conference = conferences.find(c => c.id === conferenceId);
      const baseAmount = getPriceByCurrency(conference, selectedCurrency);

      // Update coupon code
      participant.couponCodes = {
        ...participant.couponCodes,
        [conferenceId]: newValue
      };

      // Reset discount and validity initially
      participant.couponDiscounts = {
        ...participant.couponDiscounts,
        [conferenceId]: 0
      };
      participant.couponValidity = {
        ...participant.couponValidity,
        [conferenceId]: false
      };

      if (!newValue) {
        // Clear coupon
        participant.couponMessages = {
          ...participant.couponMessages,
          [conferenceId]: ''
        };
      } else if (!matchingCoupon) {
        // Invalid coupon
        participant.couponMessages = {
          ...participant.couponMessages,
          [conferenceId]: 'The Coupon is not correct'
        };
      } else {
        // Check if used or expired
        const isUsed = conferenceUsedCoupons.some(c => c.coupon_code === newValue);
        const isExpired = matchingCoupon.coupon_expire_date <= currentDate;

        const isUsedLocally = participants.some((p, idx) => {
          if (idx === participantIndex) return false;
          return Object.values(p.couponCodes || {}).includes(newValue);
        });

        if (isUsed) {
          participant.couponMessages = {
            ...participant.couponMessages,
            [conferenceId]: 'The Coupon is Already used'
          };
        }
        else if (isUsedLocally) {
          participant.couponMessages = {
            ...participant.couponMessages,
            [conferenceId]: 'This coupon code is already used in the group'
          };
        } else if (isExpired) {
          participant.couponMessages = {
            ...participant.couponMessages,
            [conferenceId]: 'The Coupon is Expired'
          };
        } else {
          // Valid coupon - calculate discount
          let discount = 0;
          if (matchingCoupon.coupon_amout_type === "percentage") {
            discount = (baseAmount * matchingCoupon.coupon_amout_value) / 100;
          } else if (matchingCoupon.coupon_amout_type === "fixed") {
            discount = matchingCoupon.coupon_amout_value;
          }

          participant.couponDiscounts = {
            ...participant.couponDiscounts,
            [conferenceId]: discount
          };
          participant.couponValidity = {
            ...participant.couponValidity,
            [conferenceId]: true
          };
          participant.couponMessages = {
            ...participant.couponMessages,
            [conferenceId]: 'Discount applied!'
          };
        }
      }

      return updated;
    });
  };

  // Calculate total amount whenever relevant data changes
  useEffect(() => {
    let newTotalAmount = 0;
    let newTotalAmountPrice = 0;
    participants.forEach((participant, participantIndex) => {
      const conferences = participantConferenceCategories[participantIndex] || [];

      participant.selectedConferences?.forEach(confId => {
        const conference = conferences.find(c => c.id === confId);
        if (!conference) return;

        const baseAmount = getPriceByCurrency(conference, selectedCurrency);
        const discount = participant.couponDiscounts?.[confId] || 0;
        newTotalAmount += baseAmount - discount;
        newTotalAmountPrice += baseAmount;
      });
    });

    setTotalAmountPrice(newTotalAmountPrice);
    setTotalAmountCouponAplied(newTotalAmount);
  }, [participants, participantConferenceCategories, selectedCurrency]);

  // Update participant data
  const handleChange = (index, field, value) => {
    setParticipants(prev => {
      const updated = [...prev];
      updated[index] = { ...updated[index], [field]: value };
      return updated;
    });
  };

  // Add new participant
  const addParticipant = () => {
    if (participants.length >= MAX_PARTICIPANTS) {
      alert(`Maximum ${MAX_PARTICIPANTS} participants allowed.`);
      return;
    }

    setParticipants(prev => [
      ...prev.map((p, i) => ({ ...p, isParent: i === 0 })),
      {
        title: '',
        name: '',
        email: '',
        phone: '',
        profession: '',
        gender: '0',
        country: 'Saudi Arabia',
        city: '',
        category: '',
        isParent: false,
        selectedConferences: [],
        couponCodes: {},
        couponDiscounts: {},
        couponMessages: {},
        couponValidity: {},
      },
    ]);
  };

  // Remove participant
  const removeParticipant = (index) => {
    if (index === 0) return;
    setParticipants(prev => {
      const updated = prev.filter((_, i) => i !== index);
      if (updated.length > 0) updated[0].isParent = true;
      return updated;
    });
  };

  // Get participant amounts
  const getParticipantAmounts = (participant, participantIndex) => {
    let total = 0;
    let discountedTotal = 0;
    let totalDiscount = 0;

    const selected = participant.selectedConferences || [];
    const confList = participantConferenceCategories[participantIndex] || [];

    selected.forEach(conferenceId => {
      const conf = confList.find(c => c.id === conferenceId);
      if (!conf) return;

      const baseAmount = getPriceByCurrency(conf, selectedCurrency);
      const discount = parseFloat(participant.couponDiscounts?.[conferenceId] || 0);

      total += baseAmount;
      discountedTotal += (baseAmount - discount);
      totalDiscount += discount;
    });

    return { total, discountedTotal, totalDiscount };
  };

  // Render conference price with discount if applicable
  const renderConferencePrice = (conference, participant) => {
    const baseAmount = getPriceByCurrency(conference, selectedCurrency);
    const discount = participant.couponDiscounts?.[conference.id] || 0;
    const currencySymbol = currencySymbols[selectedCurrency] || '';

    if (discount > 0) {
      return (
        <>
          <span style={{ textDecoration: 'line-through' }}>
            {currencySymbol} {baseAmount.toFixed(2)}
          </span>
          {' '}
          <span style={{ color: 'green' }}>
            {currencySymbol} {(baseAmount - discount).toFixed(2)}
          </span>
        </>
      );
    }
    return <span style={{ color: 'green' }}>{currencySymbol} {baseAmount.toFixed(2)}</span>;
  };

  // Submit registration
  const handleSubmit = () => {
    const isValid = participants.every(p =>
      p.name && p.email && p.phone && p.category && p.selectedConferences?.length > 0
    );

    if (!isValid) {
      swal('Error', 'Please fill all required fields for all participants', 'error');
      return;
    }

    const submissionData = {
      eventId: eventid,
      currency: selectedCurrency,
      participants: participants.map((p, index) => {
        const { total, discountedTotal, totalDiscount } = getParticipantAmounts(p, index);

        return {
          ...p,
          individualAmount: {
            original: total,
            discounted_paid_amount: discountedTotal,
            totalDiscount: totalDiscount,
          }
        };
      }),
      totalAmountCouponAplied,
      totalAmountPrice,
    };

    axios.post('api/conference-group-registration', submissionData)
      .then(res => {
        if (res.data.status === 200) {
          swal(
            'Success',
            `Registration submitted successfully! Total participants inserted: ${res.data.totalInserted}`,
            'success'
          );
        } else if (res.data.status === 409) {
          setAlredayRegisteredEmail(res.data.already_registered_emails || []);
          swal(
            'Notice',
            `Some emails were already registered. Please check highlighted fields.`,
            'warning'
          );
        }
        else {
          swal('Error', res.data.message || 'Registration failed', 'error');
        }
      })
      .catch(err => {
        swal('Error', err.response?.data?.message || 'Registration failed', 'error');
      });
  };

  const handleOnlineSubmit = () => {
    const isValid = participants.every(p =>
      p.name && p.email && p.phone && p.category && p.selectedConferences?.length > 0
    );

    if (!isValid) {
      swal('Error', 'Please fill all required fields for all participants', 'error');
      return;
    }

    const submissionData = {
      eventId: eventid,
      currencyIsPay: selectedCurrency,
      participants: participants.map((p, index) => {
        const { total, discountedTotal, totalDiscount } = getParticipantAmounts(p, index);

        return {
          ...p,
          individualAmount: {
            original: total,
            discounted_paid_amount: discountedTotal,
            totalDiscount: totalDiscount,
          }
        };
      }),
      totalAmountCouponAplied,
      totalAmountPrice,
      paymentMethod: 'online',
      paymentType: 'group',
    };

    axios.post('api/onlinepayment-grp-conference-particpant-store', submissionData)
      .then(res => {
        if (res.data.status === 200) {
          window.location.href = res.data.redirect.redirect_url;
        } else if (res.data.status === 409) {
          setAlredayRegisteredEmail(res.data.already_registered_emails || []);
          swal(
            'Notice',
            `Some emails were already registered. Please check highlighted fields.`,
            'warning'
          );
        }
        else {
          swal('Error', res.data.message || 'Registration failed', 'error');
        }
      })
      .catch(err => {
        swal('Error', err.response?.data?.message || 'Registration failed', 'error');
      });
  };

  return (
    <>
      <Grid item xs={12} sm={10} md={8} lg={6}>
        <ConferenceNavbar />
      </Grid>
      <Box p={2}>

        <Typography variant="h5" gutterBottom>
          Group Registration
        </Typography>
        <Typography variant="subtitle1" color="primary" gutterBottom>
          Total Amount: {currencySymbols[selectedCurrency]} {totalAmountCouponAplied.toFixed(2)}
          <br />
          Total Price without Discount: {currencySymbols[selectedCurrency]} {totalAmountPrice.toFixed(2)}
        </Typography>

        <Button
          sx={{
            float: 'right',
            marginTop: '2%',
            marginRight: '50px',
            ":hover": { color: "white" },
            backgroundColor: abstractHomeSetup.color_code_two || gradientBackground,
          }}
          color='success'
          size='small'
          variant='contained'
          onClick={() => history.goBack()}
        >
          Back
        </Button>

        <Box sx={{ p: 2, display: 'flex', justifyContent: 'flex-end' }}>
          <FormControl sx={{ minWidth: 120 }}>
            <InputLabel>Currency</InputLabel>
            <Select
              value={selectedCurrency}
              label="Currency"
              onChange={handleCurrencyChange}
              disabled={event_affiliate_status ? true : false}
            >
              {currencyOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>

        {participants.map((participant, index) => (
          <Box
            key={index}
            mb={3}
            p={3}
            border={1}
            borderColor="grey.300"
            borderRadius={2}
          >
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography mb={2}>Participant {index + 1}</Typography>
              {!participant.isParent && (
                <IconButton onClick={() => removeParticipant(index)} color="error">
                  <Delete />
                </IconButton>
              )}
            </Box>

            <Grid container spacing={2}>
              {/* Personal Information Fields */}
              <Grid item xs={12} sm={6} md={4}>
                <FormControl fullWidth>
                  <InputLabel>Title</InputLabel>
                  <Select
                    value={participant.title}
                    onChange={(e) => handleChange(index, 'title', e.target.value)}
                    label="Title"
                  >
                    {titles.map((t) => (
                      <MenuItem key={t} value={t}>{t}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  label="Full Name *"
                  fullWidth
                  value={participant.name}
                  onChange={(e) => handleChange(index, 'name', e.target.value)}
                  required
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  label="Email *"
                  fullWidth
                  type="email"
                  value={participant.email}
                  onChange={(e) => handleChange(index, 'email', e.target.value)}
                  required
                  error={alreadyRegisteredEmails.includes(participant.email.trim())}
                  helperText={
                    alreadyRegisteredEmails.includes(participant.email.trim())
                      ? 'This email is already registered.'
                      : ''
                  }
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  label="Mobile *"
                  fullWidth
                  value={participant.phone}
                  onChange={(e) => handleChange(index, 'phone', e.target.value)}
                  required
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  label="Profession"
                  fullWidth
                  value={participant.profession}
                  onChange={(e) => handleChange(index, 'profession', e.target.value)}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <FormControl component="fieldset">
                  <RadioGroup
                    row
                    value={participant.gender}
                    onChange={(e) => handleChange(index, 'gender', e.target.value)}
                  >
                    <FormControlLabel value="0" control={<Radio />} label="Male" />
                    <FormControlLabel value="1" control={<Radio />} label="Female" />
                  </RadioGroup>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <FormControl fullWidth>
                  <InputLabel>Country</InputLabel>
                  <Select
                    value={participant.country}
                    onChange={(e) => handleChange(index, 'country', e.target.value)}
                    label="Country"
                  >
                    {countries.map((c) => (
                      <MenuItem key={c} value={c}>{c}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <TextField
                  label="City"
                  fullWidth
                  value={participant.city}
                  onChange={(e) => handleChange(index, 'city', e.target.value)}
                />
              </Grid>


              <Grid item xs={12} sm={6} md={4}>
                <FormControl fullWidth>
                  <InputLabel>Category *</InputLabel>
                  <Select
                    value={participant.category}
                    onChange={(e) => handleregistration(e, index)}
                    label="Category"
                    required
                  >
                    {conferenceCategoryData.map((cat) => (
                      <MenuItem key={cat.id} value={cat.id}>
                        {cat.conference_category_title || cat.title || cat.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>

              {/* Conference Selection */}
              {participantConferenceCategories[index]?.map((conf, i) => (
                <Grid item xs={12} sm={6} md={4} key={i}>
                  <Box
                    p={2}
                    border={1}
                    borderColor="grey.300"
                    borderRadius={2}
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Box>
                      <Typography variant="h6" fontWeight="700" gutterBottom>
                        {conf.conference_name}
                      </Typography>
                      <Typography variant="body2" color="text.secondary" mb={0.5}>
                        <strong>Day:</strong> {conf.conference_day}
                      </Typography>
                      <Typography variant="body2" color="text.secondary" mb={0.5}>
                        <strong>Seats Available:</strong> {conf.conference_no_ofseats}
                      </Typography>
                      <Typography>
                        {conf.conference_date} | {conf.conference_start_time} - {conf.conference_end_time}
                      </Typography>
                      <Typography>Amount: {renderConferencePrice(conf, participant)}</Typography>
                      {conf.conference_coupon && (
                        <Box mt={1}>
                          <TextField
                            size="small"
                            label="Coupon Code"
                            value={participant.couponCodes?.[conf.id] || ''}
                            onChange={(e) => handleCouponCodeChange(conf.id, e.target.value, index)}
                            error={!!participant.couponMessages?.[conf.id] &&
                              !participant.couponMessages?.[conf.id].includes('Discount applied!')}
                            helperText={participant.couponMessages?.[conf.id] || ''}
                          />
                        </Box>
                      )}
                    </Box>
                    <Checkbox
                      checked={participant.selectedConferences?.includes(conf.id)}
                      onChange={(e) => {
                        const checked = e.target.checked;
                        setParticipants(prev => {
                          const updated = [...prev];
                          updated[index] = {
                            ...updated[index],
                            selectedConferences: checked
                              ? [...(updated[index].selectedConferences || []), conf.id]
                              : (updated[index].selectedConferences || []).filter(id => id !== conf.id)
                          };
                          return updated;
                        });
                      }}
                    />
                  </Box>
                </Grid>
              ))}

              {participant.isParent && (
                <Grid item xs={12}>
                  <Typography color="primary" variant="body2">
                    Primary Participant (Cannot be removed)
                  </Typography>
                </Grid>
              )}
            </Grid>
          </Box>
        ))}

        <Box mb={2} display="flex" justifyContent="flex-end" gap={2}>
          <Button
            variant="contained"
            startIcon={<Add />}
            onClick={addParticipant}
            disabled={participants.length >= MAX_PARTICIPANTS}
          >
            Add Participant
          </Button>

          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            size="large"
          >
            Submit Registration ({currencySymbols[selectedCurrency]} {totalAmountCouponAplied.toFixed(2)})
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleOnlineSubmit}
            size="large"
          >
            Online Pay ({currencySymbols[selectedCurrency]} {totalAmountCouponAplied.toFixed(2)})
          </Button>
        </Box>
      </Box>
    </>
  );
};

export default ConferenceParticipantGroupRegistration;